module.exports = __webpack_public_path__ + "img/koposov.3255c205.jpg";